import { render, staticRenderFns } from "./DueDataStandard.vue?vue&type=template&id=60827d98&scoped=true"
import script from "./DueDataStandard.vue?vue&type=script&lang=js"
export * from "./DueDataStandard.vue?vue&type=script&lang=js"
import style0 from "./DueDataStandard.vue?vue&type=style&index=0&id=60827d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60827d98",
  null
  
)

export default component.exports